module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAAYCAYAAADEQnB9AAAABHNCSVQICAgIfAhkiAAAAUlJREFUeJzt2zFOw0AQheEZk6BIRLhJ6LgA16AFanKASNwpFU0OAKLMNbgAZZRIQIIoWA8FEkWURcax4x34v8pajeRx8bRra6w3tw8XAsClrO0GAFRHgAHHCDDgGAEGHOu03UAZZna/bV1VL1OtqaLJ/kzEMtUrERFTVSmKu11rqqjr3vusSRk7MOAYAQYcI8CAYwQYcIwAA45pbJSy9/R43n2ej011/XE8mL6fns323RzwX5XNX3QHPlwtR6pylImddF/m4+ZaBbCpbP6iAbYQ+t/Xouu6GwQQVzZ/0UGOkA8nndVyZCH0i3wwrbvB30htSMPjIEdTNVWk9gxNPecuQj6cHLwurqWwH/MXDfDb15mb916gBWXzx1dowDECDDhGgAHHXPyNhL/NRExERLesbWqrJlXRQQ4A6eMIDThGgAHHCDDgVGFmn89y25Lhrr4WAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/racks/drawer-5-selected.png
// module id = Deql
// module chunks = 0